import { SxProps, Theme } from '@mui/material';

export const tabsStyles = {
	wrapper: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		position: 'relative',
		zIndex: 4,
	},
	innerWrapper: {
		marginBottom: '16px',
		minHeight: '38px',
		'& .MuiTabs-flexContainer': {
			gap: '2px',
		},
		'& .MuiTabs-indicator': {
			display: 'none',
		},
	},
	tab: {
		color: 'rgba(255, 255, 255, 0.5)',
		fontFamily: 'Montserrat',
		fontSize: '14px',
		lineHeight: '17px',
		fontWeight: 600,
		padding: '10.5px 20px',
		backgroundColor: 'rgba(255, 255, 255, 0.05)',
		width: '190px',
		textTransform: 'none',
		minHeight: '38px',

		'&.Mui-selected': {
			color: 'black',
			backgroundColor: 'white',
		},

		'@media (max-width: 600px)': {
			padding: '10.5px 15px',
			width: '180px',
		},
	},
	title: {
		fontFamily: 'Montserrat',
		fontSize: '13px',
		lineHeight: '21px',
		fontWeight: 700,
		color: 'white',
		textAlign: 'center',
		marginBottom: '16px',
	},
};
